import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import './_attendanceReport.scss'
import ReportTableData from './ReportTableData'
import EmployeeAttendanceSection from '../employeeAttendance/employeeAttendanceSection';
import ReportDateBlock from "../student_attendance_report/ReportDateBlock";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../utils/moduleGuard";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

// /Employee_Attendance_Report → "Student_Attendance" (see MODULE_ROUTES in
// moduleAccessGuard — this route is keyed off the same attendance grant).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const EMPLOYEE_ATTENDANCE_MODULE = ["Student_Attendance"];

const GET_EMPLOYEE_ROLES = gql`
  query($institute_id: Int) {
    getEmployeeRoles(institute_id: $institute_id) {
      id
      role_name
    }
  }
`;

class EmployeeAttendanceReportSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            tableHeadMonths: [],
            getEmployeeeAttendanceReport: [],
            attendanceTypes: [],
            showAddModal: false,
            hasSearched: false,
            employee_roles: [],
            accessDeniedShow: false,
        }

        this.guard = attachModuleGuard(this, EMPLOYEE_ATTENDANCE_MODULE);
    }

    // "Add Attendance" — opens the embedded EmployeeAttendanceSection modal, which owns
    // the actual marking/saving mutation. Gating the opener is what stops the write; the
    // button itself stays visible and clickable.
    openAddAttendanceModal = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ showAddModal: true });
    };

    componentDidMount() {
        // is_view === 0 → don't fetch the report. Both reads here are imperative
        // client.query() calls, so there's no graphql HOC to put a `skip` on — bailing
        // out here is what keeps the attendance data off the wire.
        if (!this.guard.canView()) return;

        this.getEmployeeeAttendanceReport();
        this.getEmployeeRoles();
        // Branch comes from the header (NavbarOne) — refetch when the selection changes.
        this.offBranchScope = onBranchScopeChange(() => this.getEmployeeeAttendanceReport());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            (!prevProps.globals?.globalBranches?.length && this.props.globals?.globalBranches?.length) ||
            (prevProps.globals?.globalBranches !== this.props.globals?.globalBranches)
        ) {
            this.getEmployeeeAttendanceReport();
        }
    };

    // The branches this report covers: the header's selection, narrowed to the
    // branches the user is authorized for.
    scopedBranchIds = () =>
        scopeBranches(this.props.globals?.globalBranches || []).map((b) => parseInt(b.id));


    getEmployeeRoles = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_EMPLOYEE_ROLES,
                variables: { institute_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            this.setState({ employee_roles: (result.data && result.data.getEmployeeRoles) || [] });
        } catch {
            this.setState({ employee_roles: [] });
        }
    };


    getEmployeeeAttendanceReport = async () => {
        // The header's branch selection scopes this report. getEmployeeeAttendanceReport
        // takes a single branch_id, so fan the query out across the selected branches
        // and concatenate — every row already carries its own branch_id.
        const branchIds = this.scopedBranchIds();

        if (branchIds.length === 0) {
            this.setState({ getEmployeeeAttendanceReport: [], loadingSpinner: 0, hasSearched: true })
            return ""
        }

        this.setState({ loadingSpinner: 1 })

        try {
            const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
                fetchPolicy: "network-only",
                query: gql`
                query(
                    $institute_id: Int
                    $branch_id: Int
                    $startTime: String
                    $EndTime: String
                ){
                    getEmployeeeAttendanceReport(
                        institute_id: $institute_id
                        branch_id: $branch_id
                        startTime: $startTime
                        EndTime: $EndTime
                    ) {
                        employee_id
                        employee_name
                        employee_type
                        employee_role
                        employee_role_id
                        branch_id
                        employee_stats {
                            total_days
                            present_days
                            absent_days
                            half_days
                            month
                            month_num
                            percentage
                            monthlyReport {
                                date
                                status
                            }
                        }
                    }
                }
                `,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: branch_id,
                    startTime: String(this.state.startDateCalender),
                    EndTime: String(this.state.endDateCalender),
                }
            })))

            const rows = results.flatMap((r) => (r.data && r.data.getEmployeeeAttendanceReport) || [])

            if (rows.length > 0) {
                let months = rows[0].employee_stats.map((item) => item.month)
                this.setState({
                    getEmployeeeAttendanceReport: rows,
                    loadingSpinner: 0,
                    tableHeadMonths: months,
                    hasSearched: true,
                })
            } else {
                this.setState({
                    getEmployeeeAttendanceReport: [],
                    loadingSpinner: 0,
                    hasSearched: true,
                })
            }
        } catch (err) {
            console.error("getEmployeeeAttendanceReport error:", err)
            this.setState({ loadingSpinner: 0, hasSearched: true })
        }
    };

    applyCallback = (startDate, endDate) => {
        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix(),
            getEmployeeeAttendanceReport: [],
            hasSearched: false,
        }, () => {
            this.getEmployeeeAttendanceReport();
        })
    }

    renderShimmer() {
        return (
            <>
                <style>{`
                    @keyframes earShimmer {
                        0%   { background-position: -800px 0; }
                        100% { background-position:  800px 0; }
                    }
                    .ear-shimmer {
                        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
                        background-size: 800px 100%;
                        animation: earShimmer 1.4s infinite linear;
                        border-radius: 6px;
                    }
                `}</style>

                {/* 4 Shimmering Summary Cards */}
                <Row className="mb-4">
                    {[1, 2, 3, 4].map((i) => (
                        <Col key={i} lg={3} md={6} sm={12} className="mb-3">
                            <Card className="ea-card shadow-sm" style={{ border: 'none', borderTop: '4px solid #cbd5e1', borderRadius: '12px', marginBottom: 0 }}>
                                <Card.Body className="p-3">
                                    <div className="ear-shimmer mb-2" style={{ height: 14, width: '60%' }} />
                                    <div className="ear-shimmer mb-2" style={{ height: 28, width: '40%' }} />
                                    <div className="ear-shimmer" style={{ height: 11, width: '80%' }} />
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Shimmering Table */}
                <div className="ea-table-wrapper" style={{ border: '1px solid #cbd5e1' }}>
                    <div style={{ padding: '16px', background: '#f8fafc', borderBottom: '1px solid #cbd5e1', display: 'flex', gap: '20px' }}>
                        <div className="ear-shimmer" style={{ height: 16, width: '180px' }} />
                        <div className="ear-shimmer" style={{ height: 16, width: '140px' }} />
                        <div className="ear-shimmer" style={{ height: 16, width: '380px' }} />
                    </div>
                    {[1, 2, 3, 4, 5].map((rowIdx) => (
                        <div key={rowIdx} style={{ padding: '16px', borderBottom: '1px solid #cbd5e1', display: 'flex', gap: '20px', alignItems: 'center', background: '#fff' }}>
                            <div className="ear-shimmer" style={{ height: 24, width: '180px' }} />
                            <div className="ear-shimmer" style={{ height: 16, width: '140px' }} />
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <div className="ear-shimmer" style={{ height: 52, width: '120px', borderRadius: '12px' }} />
                                <div className="ear-shimmer" style={{ height: 52, width: '120px', borderRadius: '12px' }} />
                                <div className="ear-shimmer" style={{ height: 52, width: '120px', borderRadius: '12px' }} />
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    render() {
        // is_view === 0 → the attendance report is never rendered, and componentDidMount
        // bails out before fetching it. The page shell (navbar / sidebar / footer) comes
        // from EmployeeAttendanceReport.jsx, so the user can still navigate elsewhere.
        if (!this.guard.canView()) {
            return (
                <div style={styles.page}>
                    <AccessDeniedCard />
                </div>
            );
        }

        const {
            loadingSpinner,
            getEmployeeeAttendanceReport,
        } = this.state;
        const hasData = getEmployeeeAttendanceReport.length > 0;

        let totalEmployees = 0;
        let sumTotalDays = 0;
        let sumPresentDays = 0;
        let sumAbsentDays = 0;
        let sumHalfDays = 0;

        let presentPct = 0;
        let absentPct = 0;
        let halfDayPct = 0;

        if (hasData && getEmployeeeAttendanceReport.length > 0) {
            totalEmployees = getEmployeeeAttendanceReport.length;
            sumTotalDays = getEmployeeeAttendanceReport[0]?.employee_stats.reduce(
                (total, item) => total + Number(item.total_days || 0),
                0
            );

            getEmployeeeAttendanceReport.forEach(emp => {
                if (emp.employee_stats?.length) {
                    emp.employee_stats.forEach(stat => {
                        sumPresentDays += Number(stat.present_days || 0);
                        sumAbsentDays += Number(stat.absent_days || 0);
                        sumHalfDays += Number(stat.half_days || 0);
                    });
                }
            });

            const totalCapacity = sumTotalDays;
            if (totalCapacity > 0) {
                presentPct = ((sumPresentDays / totalCapacity) * 100).toFixed(2);
                absentPct = ((sumAbsentDays / totalCapacity) * 100).toFixed(2);
                halfDayPct = ((sumHalfDays / totalCapacity) * 100).toFixed(2);
            }
        }

        console.log(
            "test", {
            totalEmployees,
            sumTotalDays,
            sumPresentDays,
            sumAbsentDays,
            sumHalfDays
        });

        const styles = {
            page: {
                background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
                minHeight: "100vh",
                padding: "28px 24px",
            }
        };

        return (
            <div style={styles.page}>
                <div className="ea-card">
                    <div className="ea-card-body">
                        <div className="ea-header-bar">
                            <div className="ea-header-left">
                                <span className="ea-header-icon">
                                    <i className="fal fa-chart-bar" />
                                </span>
                                <h2 className="ea-header-title">
                                    Employee Attendance
                                </h2>
                            </div>
                            <button onClick={this.openAddAttendanceModal} className="ea-btn-primary">
                                <i className="fal fa-plus" />
                                Add Attendance
                            </button>
                        </div>

                        {/* No Branch filter — the header's branch selection scopes this report. */}
                        <div className="ea-filters-grid">
                            <div className="ea-filter-group">
                                <label className="ea-label">Date Range</label>
                                <ReportDateBlock
                                    applyCallback={this.applyCallback}
                                    start={this.start}
                                    end={this.end}
                                    stateData={this.props.stateData}
                                />
                            </div>
                        </div>

                        <Row>
                            <Col lg={12}>
                                {loadingSpinner == 1 ? (
                                    this.renderShimmer()
                                ) : hasData ? (
                                    <>
                                        <Row className="mb-4">
                                            {[
                                                {
                                                    label: "Total Employees",
                                                    value: totalEmployees,
                                                    subtext: `Total Days: ${sumTotalDays} Days`,
                                                    color: "#6366f1",
                                                    icon: "fas fa-users"
                                                },
                                                {
                                                    label: "Total Present",
                                                    value: `${sumPresentDays} Days`,
                                                    subtext: `${presentPct}% Attendance Rate`,
                                                    color: "#10b981",
                                                    icon: "fas fa-check-circle"
                                                },
                                                {
                                                    label: "Total Leave",
                                                    value: `${sumAbsentDays} Days`,
                                                    subtext: `${absentPct}% Leave Rate`,
                                                    color: "#ef4444",
                                                    icon: "fas fa-times-circle"
                                                },
                                                {
                                                    label: "Total Half Day",
                                                    value: `${sumHalfDays} Days`,
                                                    subtext: `${halfDayPct}% Half Day Rate`,
                                                    color: "#f59e0b",
                                                    icon: "fas fa-clock"
                                                }
                                            ].map((stat, idx) => (
                                                <Col key={idx} lg={3} md={6} sm={12} className="mb-3">
                                                    <Card className="shadow-sm" style={{ border: 'none', borderTop: `4px solid ${stat.color}`, borderRadius: '12px', height: '100%' }}>
                                                        <Card.Body className="p-3">
                                                            <div className="d-flex align-items-center mb-2" style={{ gap: '8px', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                                <i className={stat.icon} style={{ color: stat.color, fontSize: '13px' }}></i>
                                                                {stat.label}
                                                            </div>
                                                            <h4 className="font-weight-bold mb-0" style={{ color: '#0f172a', fontSize: '24px' }}>
                                                                {stat.value}
                                                            </h4>
                                                            <div className="mt-2 text-muted" style={{ fontSize: '12px', fontWeight: '500' }}>
                                                                {stat.subtext}
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                        <ReportTableData stateData={this.state} globals={this.props.globals} />
                                    </>
                                ) : this.state.hasSearched ? (
                                    <div className="text-center py-5 text-muted font-weight-bold" style={{ background: '#fff', borderRadius: '12px', border: '1px solid #cbd5e1', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                                        <i className="fal fa-folder-open mb-3" style={{ fontSize: '48px', color: '#94a3b8', display: 'block' }}></i>
                                        <div style={{ fontSize: '15px', color: '#475569' }}>No data found</div>
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                    </div>
                </div>


                <Modal
                    show={this.state.showAddModal}
                    onHide={() => this.setState({ showAddModal: false })}
                    size="xl"
                    dialogClassName="ea-modal-dialog"
                >
                    <Modal.Body style={{ padding: 0 }}>
                        <EmployeeAttendanceSection
                            globals={this.props.globals}
                            embedded
                            onClose={() => this.setState({ showAddModal: false })}
                        />
                    </Modal.Body>
                </Modal>

                {/* Shown instead of opening the Add Attendance modal when is_edit is
                    missing. This module has no delete surface. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />

                <ToastContainer />
            </div>
        )
    }
}

export default withRouter(withApollo((EmployeeAttendanceReportSection)));
